import BaseAPI from './base'

class SurveyAPI extends BaseAPI {}

export default new SurveyAPI('v1/survey', 'Survey')
